import { TFunction } from "i18next";

import { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

import { countryISOMapping } from "checkout-experience/utils/mappers/countryIso3to2";

export const countrySpecificFields = [
  "billingAddressAdministrativeArea",
  "billingAddressZip",
];

export const getBetterCardNetworkError = (
  t: TFunction<"translation", undefined>,
  exists: (key: string) => boolean,
  fieldId: string,
  errorMessage: string,
  notAllowedCardType: string,
  supportedPaymentTypes?: CreditCardNetwork[]
) => {
  const notSupportedCardNetwork = t(
    `checkoutForm.${fieldId}.cardNames.${notAllowedCardType}`
  );

  const length = supportedPaymentTypes?.length ?? 0;
  const last = t(
    `checkoutForm.${fieldId}.cardNames.${supportedPaymentTypes?.[length - 1]}`
  );
  let supportedPaymentTypesString = supportedPaymentTypes
    ?.slice(0, length - 1)
    ?.map((type) => t(`checkoutForm.${fieldId}.cardNames.${type}`))
    .join(", ");
  supportedPaymentTypesString = supportedPaymentTypesString
    ? [supportedPaymentTypesString, last].join(", or ")
    : last;

  const translationErrorKey = exists(
    `checkoutForm.${fieldId}.cardNames.${notAllowedCardType}`
  )
    ? "cardNetworkKnownCard"
    : "cardNetworkUnknownCard";

  return t(`checkoutForm.${fieldId}.errors.${translationErrorKey}`, {
    notSupportedCardNetwork: notSupportedCardNetwork,
    supportedCardNetworksList: supportedPaymentTypesString,
  });
};

// Validate country code to iso 3166 alpha 2
export const validateCountryCode = (value: string) => {
  if (value.length === 2) {
    return value;
  }

  return countryISOMapping[value] ?? value;
};

export const billingAddressCountrySpecificFields = (
  fieldId: string,
  countryFieldValue: string
): string => {
  /**
   * Defaults are:
   * billingAddressZip: Postal Code
   * billingAddressAdministrativeArea: Province
   *
   * Below changes them based on specific country values
   * */

  if (fieldId === "billingAddressAdministrativeArea") {
    if (
      [
        "AU",
        "AT",
        "BR",
        "DE",
        "IN",
        "MY",
        "MX",
        "FM",
        "MM",
        "NZ",
        "NG",
        "PW",
        "SD",
        "SS",
        "US",
      ].includes(countryFieldValue)
    ) {
      return ".state";
    }
    if (
      ["AL", "GB", "HR", "HU", "IR", "KR", "LR", "NO", "RO", "SE"].includes(
        countryFieldValue
      )
    ) {
      return ".county";
    }
  }

  if (fieldId === "billingAddressZip") {
    if (
      ["AS", "GU", "MH", "MP", "PR", "VI", "PW", "FM", "US"].includes(
        countryFieldValue
      )
    ) {
      return ".zipcode";
    }
    if (
      ["GB", "GG", "GI", "IM", "JE", "DE", "NL"].includes(countryFieldValue)
    ) {
      return ".postcode";
    }
  }

  // always return empty string if nothing matches above
  return "";
};
